<div class="row">
  @if (canShowSideNavidation) {
    <app-side-navigation class="col-12 col-lg-2 sidenav-block"></app-side-navigation>
  }

  <div class="col-12" [class.m-lg-auto]="!canShowSideNavidation" [class.col-lg-10]="!isFocusModeActive">
    <router-outlet></router-outlet>
  </div>
</div>

@if (showChatWidget) {
  <app-chat-widget></app-chat-widget>
}
